import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const ContentProcessModule: FlowModuleTemplateType = {
  id: 'ContentEditModule',
  templateType: ModuleTemplateTypeEnum.logicDeal,
  flowType: FlowNodeTypeEnum.contentProcess,
  name: '文本加工',
  description: '对输入的文本内容进行包装',
  isTool: true,
  inputs: [
    Input_Template_Switch,
    {
      label: '文本编辑',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.textarea,
      key: ModuleInputKeyEnum.template,
      required: true,
      description: '要进行的文本处理',
    },
    {
      label: '代加工文本',
      valueType: ModuleIOValueTypeEnum.string,
      description: '要进行的文本处理',
      type: FlowNodeInputTypeEnum.addInputParam,
      key: ModuleInputKeyEnum.addTemplate,
      edit: false,
      editField: {
        dataType: true,
        description: true,
        key: true,
        name: true,
        required: true,
      },
      defaultEditFieldValue: {
        valueType: 'string',
        required: true,
      },
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.contentEditResult,
      targets: [],
      valueType: ModuleIOValueTypeEnum.string,
      description: '经过加工后的文本',
      label: '加工后文本',
      type: FlowNodeOutputTypeEnum.source,
    },
  ],
};
